import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import Filters, {
  IFilterData,
} from "../../components/Catalogs/Filters/Filters";
import useDataLoader2 from "../../hooks/useDataLoader2";
import { defaultPageSize } from "../../utils/const";
import { useContext, useEffect, useMemo, useState } from "react";
import ArticlesCard from "../ManageFirm/Profile/ArticleCard";
import { useSearchParams } from "react-router-dom";
import { isApprovedEnum } from "../../Enums/ContentEnums";
import { UsePracticeIndustryList } from "../../hooks/Catalogs/usePracticeIndustry";
import AuthContext from "../../store/AuthContext";
import { ContentType } from "../../interfaces";
import ContentPaginationControl from "../../components/Content/ContentPaginationControl";

interface contentProps {
  contentType: ContentType;
}

const Content: React.FC<contentProps> = ({contentType}) => {
  const { loggedPerson } = useContext(AuthContext);

  const [searchParams] = useSearchParams();
  const firmId = searchParams.get('id');
  const { practiceIndustryData } = UsePracticeIndustryList();
  const [contentTitle, setContentTitle] = useState<string>(contentType === 'article' ? "Publications" : "Presses")

  const endpoint = "/content";
  const {
    data,
    totalCount,
    fetchData,
    setFilter,
    sort,
    setSort,
    pagination,
    setPagination,
    inputFilters,
    setInputFilters,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    defaultSorting: { field: "title", order: "asc" },
    persistentFilter: {
      memberFirms: {
        value: [firmId ?? ""],
      },
      contentType: {
        value: contentType, 
        comparisonType:'EQUAL'
      },
    },
  });

  const statusOptions = Object.entries(isApprovedEnum).map(([id, name]) => ({
    id,
    name,
  }));

  // console.log("statusOptions: ", statusOptions)

  const filtersData: IFilterData[] = useMemo(
    () => [
      {
        name: "Title",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Status",
        fieldName: "isApproved",
        objectData: statusOptions,
        disabledWrite: true,
        customTitle: "Is Approved:",
        comparison: "EQUAL"
      },
      {
        name: "Practice Industry",
        fieldName: "practiceIndustries",
        objectData: practiceIndustryData || [],
      }
    ], [practiceIndustryData, statusOptions]
  );

  useEffect(() => {
    setContentTitle(contentType === 'article' ? "Publications" : "Presses")
    fetchData(true)
    setInputFilters()
  }, [contentType])

  return (
    <>

        <CatalogTableC
          catalogName={contentTitle.toUpperCase()}
          route={contentTitle}
          totalCount={totalCount}
          noNewCatalog
        >
          <Filters
            filtersData={filtersData}
            filterValues={inputFilters}
            setFilterValues={setInputFilters}
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <div className="mt-8">
            <ArticlesCard
              articles={data ?? []}
              type={contentType}
              viewMoreLink={`view`}
            />
            <ContentPaginationControl
              pagination={pagination}
              setPagination={setPagination}
              totalCount={totalCount ?? 0}
              sort={sort}
              setSort={setSort}
              sortableFields={["title", "date"]}
            />
          </div>
        </CatalogTableC>
    </>
  );
};

export default Content;
